var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1724382719561,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9491,
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M913.536524 551.447587H116.910163c-23.637854 0-42.977915-19.340062-42.977916-42.977916s19.340062-42.977915 42.977916-42.977915h796.626361c23.637854 0 42.977915 19.340062 42.977916 42.977915s-19.340062 42.977915-42.977916 42.977916z",
    "p-id": 9492,
    fill: "#8a8a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472.194264 906.731688V110.105326c0-23.637854 19.340062-42.977915 42.977915-42.977915s42.977915 19.340062 42.977916 42.977915v796.626362c0 23.637854-19.340062 42.977915-42.977916 42.977915s-42.977915-19.340062-42.977915-42.977915z",
    "p-id": 9493,
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.ff56454e2fd15f9df6493c2cd24c92ee.svg";
export { ForwardRef as ReactComponent };